import 'antd/dist/reset.css';
import { ApolloProvider } from '@apollo/client/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import { I18nextProvider } from 'react-i18next';
import { client } from '@guuru/graphql-web';
import { ErrorBoundary } from '@guuru/react-error-pages';
import { Sentry, initSentry, handleError } from '@guuru/sentry-web';
import { COLORS } from '@guuru/theme-common';
import ThemeProvider from '@guuru/theme-web';
import { i18n } from '@guuru/translation-web';
import MainView from '../views/MainView';
import GlobalStyle from './GlobalStyle';

if (process.env.PARTNERS_GTM_ACCOUNT_ID) {
  TagManager.initialize({
    gtmId: process.env.PARTNERS_GTM_ACCOUNT_ID,
  });
}

if (process.env.PARTNERS_SENTRY_DSN) {
  initSentry(process.env.PARTNERS_SENTRY_DSN);
}

const PartnersApp = Sentry.withProfiler(() => (
  <ApolloProvider client={client}>
    <ThemeProvider theme={{ color: COLORS.primaryColor }}>
      <I18nextProvider i18n={i18n}>
        <ErrorBoundary>
          <GlobalStyle />
          <MainView />
        </ErrorBoundary>
      </I18nextProvider>
    </ThemeProvider>
  </ApolloProvider>
));

const container = document.getElementById('app');
const root = createRoot(container, {
  onCaughtError: handleError,
  onRecoverableError: handleError,
  onUncaughtError: handleError,
});

root.render(<PartnersApp />);

// Shopware waits for this message before displaying an App module iframe
if (window.parent !== window) {
  window.requestAnimationFrame(() => {
    window.parent.postMessage('sw-app-loaded', '*');
  });
}
